export default [
  {
    displayMode: 'Single',
    pageTransition: 'default',
    layout: 'single',
  },
  {
    displayMode: 'Continuous',
    pageTransition: 'continuous',
    layout: 'single',
  },
  {
    displayMode: 'Facing',
    pageTransition: 'default',
    layout: 'double',
  },
  {
    displayMode: 'FacingContinuous',
    pageTransition: 'continuous',
    layout: 'double',
  },
  {
    displayMode: 'CoverFacing',
    pageTransition: 'default',
    layout: 'cover',
  },
  {
    displayMode: 'Cover',
    pageTransition: 'continuous',
    layout: 'cover',
  },
];